export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  Department: 'Phòng ban',
  FixedAsset: 'Loại TSCĐ',
  EquipmentInventoryItem: 'Loại công cụ dụng cụ',
  ConfirmViewReport: 'Đồng ý',
};
